module.exports = __webpack_public_path__ + "img/paint.932a7ed9.png";